module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "media-list"
  }, [_c('div', {
    staticClass: "breadcrumb-bar"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/courseList'
      }
    }
  }, [_vm._v("自有课程")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v(_vm._s(_vm.breadcrumbItem))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "main-box"
  }, [_c('Card', {
    staticStyle: {
      "margin-bottom": "50px"
    }
  }, [(_vm.step == 1) ? _c('div', {
    staticClass: "panel-box"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("课包基本信息")]), _vm._v(" "), _c('div', {
    staticClass: "panel-content"
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.formPkg,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "课包名称:"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.formPkg.name),
      callback: function($$v) {
        _vm.$set(_vm.formPkg, "name", $$v)
      },
      expression: "formPkg.name"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "级别:"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "185px"
    },
    attrs: {
      "clearable": ""
    },
    on: {
      "change": _vm.levelChgHandle
    },
    model: {
      value: (_vm.formPkg.level),
      callback: function($$v) {
        _vm.$set(_vm.formPkg, "level", $$v)
      },
      expression: "formPkg.level"
    }
  }, _vm._l((_vm.levelList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "封面:"
    }
  }, [_c('el-row', {
    staticClass: "row-bg",
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "flex"
    }
  }, [(_vm.formPkg.image != '') ? _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.formPkg.image,
      "width": "80px",
      "height": "80px"
    }
  })]) : _vm._e(), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Upload', {
    attrs: {
      "action": "/aries-api/resource/upload",
      "accept": "image/jpeg, image/gif, image/png",
      "before-upload": _vm.onBeforeUpload,
      "on-success": _vm.onSuccessUploadPkgImage,
      "data": _vm.uploadData,
      "show-upload-list": false
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v("\n                      上传\n                      "), _c('i', {
    staticClass: "el-icon-upload el-icon--right"
  })])], 1)], 1), _vm._v(" "), (_vm.formPkg.image != '') ? _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-button', {
    attrs: {
      "size": "mini",
      "type": "danger"
    },
    on: {
      "click": _vm.delFrontCover
    }
  }, [_vm._v("\n                      删除\n                      "), _c('i', {
    staticClass: "el-icon-delete"
  })])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "周期:"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "185px"
    },
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.formPkg.period),
      callback: function($$v) {
        _vm.$set(_vm.formPkg, "period", $$v)
      },
      expression: "formPkg.period"
    }
  }, _vm._l((_vm.periodList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "数量:"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.formPkg.count),
      callback: function($$v) {
        _vm.$set(_vm.formPkg, "count", $$v)
      },
      expression: "formPkg.count"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "800px"
    },
    attrs: {
      "rows": 5,
      "type": "textarea"
    },
    model: {
      value: (_vm.formPkg.remark),
      callback: function($$v) {
        _vm.$set(_vm.formPkg, "remark", $$v)
      },
      expression: "formPkg.remark"
    }
  })], 1)], 1)], 1)]) : (_vm.step == 2) ? _c('div', {
    staticClass: "panel-box"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("课包编课")]), _vm._v(" "), _c('div', {
    staticClass: "panel-content"
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.formClass,
      "label-width": "90px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "展示顺序："
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入阿拉伯数字搜索"
    },
    model: {
      value: (_vm.formClass.period),
      callback: function($$v) {
        _vm.$set(_vm.formClass, "period", $$v)
      },
      expression: "formClass.period"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "级别:"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "175px"
    },
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.formClass.level),
      callback: function($$v) {
        _vm.$set(_vm.formClass, "level", $$v)
      },
      expression: "formClass.level"
    }
  }, _vm._l((_vm.levelList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "名称："
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.formClass.name),
      callback: function($$v) {
        _vm.$set(_vm.formClass, "name", $$v)
      },
      expression: "formClass.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "search"
    },
    on: {
      "click": _vm.onQuery
    }
  }, [_vm._v("搜索")])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "plus",
      "loading": _vm.addPeriodStatus
    },
    on: {
      "click": _vm.addNewPeriod
    }
  }, [_vm._v("新建一" + _vm._s(_vm.periodTxt))])], 1)], 1), _vm._v(" "), _c('div', [_c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.queryData,
      "stripe": "",
      "border": "",
      "tooltip-effect": "dark"
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "ID",
      "align": "center",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          staticStyle: {
            "color": "#1d90e6"
          },
          attrs: {
            "href": "javascript:;"
          },
          on: {
            "click": function($event) {
              return _vm.viewAlbum(scope.row.albumId, scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.id))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "order",
      "label": "展示顺序",
      "align": "center",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.order + 1))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "level",
      "label": "级别",
      "align": "center",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "名称",
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          staticStyle: {
            "color": "#1d90e6"
          },
          attrs: {
            "href": "javascript:;"
          },
          on: {
            "click": function($event) {
              return _vm.viewAlbum(scope.row.albumId, scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "image",
      "label": "图片",
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          attrs: {
            "src": scope.row.image,
            "min-width": "70",
            "height": scope.row.image != '' ? 70 : 20
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "count",
      "label": "内容数量",
      "align": "center",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "enabled",
      "label": "状态",
      "align": "center",
      "width": "85"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.enabled) ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("已上架")]) : _c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("已下架")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "updated_at",
      "label": "课程更新时间",
      "align": "center",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "show-overflow-tooltip": "",
      "align": "center",
      "width": "180",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "btnFlex"
        }, [_c('el-button', {
          staticStyle: {
            "margin-right": "5px"
          },
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.addBasciInfo(scope.$index)
            }
          }
        }, [_vm._v("基本信息")]), _vm._v(" "), _c('courseAddBook', {
          attrs: {
            "index": scope.$index
          },
          on: {
            "choseResult": _vm.multyaddBooks
          }
        })], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "type": "danger",
      "icon": "delete2"
    },
    on: {
      "click": _vm.delCourse
    }
  }, [_vm._v("删除")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "type": "primary",
      "icon": "arrow-up"
    },
    on: {
      "click": function($event) {
        return _vm.shangxiajia(true)
      }
    }
  }, [_vm._v("上架")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "type": "info",
      "icon": "arrow-down"
    },
    on: {
      "click": function($event) {
        return _vm.shangxiajia(false)
      }
    }
  }, [_vm._v("下架")]), _vm._v(" "), _c('div', {
    staticClass: "pagination-box"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.queryParams.page,
      "page-sizes": [20, 50, 100],
      "page-size": _vm.queryParams.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.pageTotal
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.queryParams, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.queryParams, "page", $event)
      }
    }
  })], 1)], 1)], 1)]) : _vm._e()]), _vm._v(" "), (_vm.step == 1) ? _c('div', [_c('el-button', {
    staticStyle: {
      "margin-left": "45%",
      "margin-top": "10px",
      "margin-bottom": "50px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.nextStep
    }
  }, [_vm._v("下一步")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.cancelEdit
    }
  }, [_vm._v("取消")])], 1) : (_vm.step == 2) ? _c('div', [_c('el-button', {
    staticStyle: {
      "margin-left": "45%",
      "margin-top": "10px",
      "margin-bottom": "50px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.confirmSubmit
    }
  }, [_vm._v("完成")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.lastStep
    }
  }, [_vm._v("上一步")])], 1) : _vm._e()], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": "760"
    },
    on: {
      "on-ok": _vm.modalConfirm,
      "on-cancel": _vm.modalCancel
    },
    model: {
      value: (_vm.modalShow),
      callback: function($$v) {
        _vm.modalShow = $$v
      },
      expression: "modalShow"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "center",
      "font-size": "15px"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('Icon', {
    attrs: {
      "type": "ios-information-circle"
    }
  }), _vm._v(" "), _c('span', [_vm._v("课程信息")])], 1), _vm._v(" "), _c('div', [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.formBasicInfo,
      "label-width": "90px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "课程名称:"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.formBasicInfo.name),
      callback: function($$v) {
        _vm.$set(_vm.formBasicInfo, "name", $$v)
      },
      expression: "formBasicInfo.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "级别:"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "175px"
    },
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.formBasicInfo.level),
      callback: function($$v) {
        _vm.$set(_vm.formBasicInfo, "level", $$v)
      },
      expression: "formBasicInfo.level"
    }
  }, _vm._l((_vm.levelList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "展示顺序:"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.formBasicInfo.order),
      callback: function($$v) {
        _vm.$set(_vm.formBasicInfo, "order", $$v)
      },
      expression: "formBasicInfo.order"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "课程图片: "
    }
  }, [_c('el-row', {
    staticClass: "row-bg",
    attrs: {
      "type": "flex"
    }
  }, [(_vm.formBasicInfo.image != '') ? _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.formBasicInfo.image,
      "width": "80px",
      "height": "80px"
    }
  })]) : _vm._e(), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Upload', {
    attrs: {
      "action": "/aries-api/resource/upload",
      "accept": "image/jpeg, image/gif, image/png",
      "before-upload": _vm.onBeforeUpload,
      "on-success": _vm.onSuccessUpload,
      "data": _vm.uploadData,
      "show-upload-list": false
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v("\n                  上传\n                  "), _c('i', {
    staticClass: "el-icon-upload el-icon--right"
  })])], 1)], 1)], 1), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "10px",
      "color": "red"
    }
  }, [_vm._v("图片推荐尺寸64px x 64px")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "课程简介:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "rows": 5,
      "type": "textarea"
    },
    model: {
      value: (_vm.formBasicInfo.desc),
      callback: function($$v) {
        _vm.$set(_vm.formBasicInfo, "desc", $$v)
      },
      expression: "formBasicInfo.desc"
    }
  })], 1)], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a4f3a39","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/course/addCourse.vue
// module id = 700
// module chunks = 1